<template lang="html">
  <v-layout
    id="representToolbar"
    class="full-height"
  >
    <v-dialog
        v-model="showCounterParametersData"
        width="1100px"
    >
      <counter-parameters-data
          v-if="showCounterParametersData"
          :is-open="showCounterParametersData"
          :counter-id="infoCounterId"
          @close="closeCounterParametersData"
      />
    </v-dialog>
    <v-layout
      v-if="
        representIsLoading ||
        pointsDataLoading ||
        pointsDataLoading ||
        pointsCountersValuesDataLoading ||
        loadingRepresentAvailablePoints
      "
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>
    <v-flex
      v-else
      d-flex
      xs12
    >
      <v-card flat class="flex-grow-1">
        <v-card-text class="represents-page">
          <v-tabs v-model="activeTab"
                  grow
                  active-class="tab-active-class"
                  icons-and-text>
            <v-tab
              v-if="representPoints.length > 0"
              href="#rep-tab-chart"
            >
              График
              <v-icon class="chart-tab">mdi-chart-bar</v-icon>
            </v-tab>
            <v-tab
              v-if="representPoints.length > 0"
              href="#rep-tab-table"
            >
              Таблица
              <v-icon class="table-tab">mdi-table</v-icon>
            </v-tab>
            <v-tab
              v-if="representPoints.length > 0"
              href="#rep-tab-cnt-val-table"
            >
              Показания счетчиков
              <v-icon class="cnt-val-table-tab">mdi-counter</v-icon>
            </v-tab>
            <v-tab href="#rep-tab-config">
              Настройка
              <v-icon class="config-tab">mdi-settings</v-icon>
            </v-tab>
            <v-tab href="#rep-tab-points">
              Точки учёта
              <v-icon class="point-tab">play_for_work</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item value="rep-tab-chart">
              <v-layout>
                <v-flex
                  xs12
                  pt-2
                >
                  <line-chart
                    v-if="!pointsDataLoading"
                    ref="pointsDataChart"
                    :chart-datasets="pointsDatasets"
                    :chart-labels="pointsDataLabels"
                  />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="rep-tab-table" class="represent-table-tab">
              <v-layout
                wrap
                class="mb-3"
              >
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn
                      rounded
                      color="primary"
                      class="ma-2"
                      :href="pointsProfileCsvUrl"
                    >
                      Экспорт
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-data-table
                    :style="opacityLoadTable"
                    :headers="pointsDataHeaders"
                    :items="pointsData"
                    :loading="pointsDataLoading"
                    hide-default-header
                    hide-default-footer
                    disable-pagination
                    fixed-header
                    dense
                  >
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th 
                            v-for="header in headers"
                            class="text-end"
                          >
                            <v-icon
                              v-if="header.sign != undefined"
                              color="teal"
                            >{{
                              header.sign == 1 ? 'add_box' :
                              header.sign == -1 ? 'indeterminate_check_box' :
                              'exposure'
                            }}</v-icon>
                            <span>{{ header.text }}</span>
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:item="{item, headers}">
                      <tr
                      >
                        <td class="nwrp width-150 text-end">
                          {{ item.counter_date }}
                        </td>
                        <td
                            v-for="header in headers"
                            v-if="header.value != 'counter_date'"
                            class="text-end"
                            :class="{ no_data_color: item[header.value] == 'x'}"
                        >
                          {{ item[header.value] }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="rep-tab-cnt-val-table" class="represent-cnt-val-tab">
              <v-layout>
                <v-flex xs4 pl-4>
                  <div class="padding-top-14">
                    Показания на
                  </div>
                </v-flex>
                <v-flex
                  d-flex
                  xs6
                >
                  <v-select
                    v-model="currentValueOnTime"
                    class="padding-left-10"
                    :items="valueOnTime"
                    item-text="text"
                    item-value="val"
                    label=""
                    persistent-hint
                    single-line
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <div class="text-center">
                    <v-btn
                      rounded
                      color="primary"
                      :href="pointsCountersValuesCsvUrl"
                    >
                      Экспорт
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout wrap v-if="!pointsCountersValuesDataLoading">
                <v-flex xs12>
                  <v-data-table
                    :headers="pointsCountersValuesHeaders"
                    :items="pointsCountersValuesData"
                    :loading="pointsCountersValuesDataLoading"
                    hide-default-header
                    hide-default-footer
                    disable-pagination
                    fixed-header
                    dense
                  >
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th 
                            v-for="header in headers"
                            class="text-end"
                          >
                            <v-icon
                              v-if="header.sign != undefined"
                              color="teal"
                            >{{
                              header.sign == 1 ? 'add_box' :
                              header.sign == -1 ? 'indeterminate_check_box' :
                              'exposure'
                            }}</v-icon>
                            <span>{{ header.text }}</span>
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:item="{item, headers}">
                      <tr
                      >
                        <td class="nwrp width-150 text-end">
                          {{ item.counter_date }}
                        </td>
                        <td
                            v-for="header in headers"
                            v-show="header.value != 'counter_date'"
                            class="text-end"
                            :class="{ no_data_color: item[header.value] == 'x'}"
                            :key="header.value"
                        >
                          {{ item[header.value] }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item
              value="rep-tab-config"
              class="conf"
            >
              <v-card flat class="width-600px">
                <v-card-text>
                  <v-container class="width-600px">
                    <v-layout wrap>
                      <v-flex xs5>
                        <v-text-field
                          ref="name"
                          v-model="editedRepresent.name"
                          label="Наименование"
                        />
                      </v-flex>
                      <v-flex xs2></v-flex>
                      <v-flex xs5>
                        <v-text-field
                          v-model="editedRepresent.remark"
                          label="Примечание"
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox
                          v-model="editedRepresent.check_health"
                          label="Проверять состояние"
                        />
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container class="width-600px" v-if="representPoints.length > 0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <div>Период</div>
                      </v-flex>
                      <v-flex>
                        <v-layout wrap>
                          <v-flex d-flex>
                            <v-radio-group
                              v-model="periodSelector"
                              class="width-100px"
                              column
                            >
                              <v-radio
                                label="Текущий"
                                value="current"
                              />
                              <v-radio
                                label="С"
                                value="selected"
                              />
                            </v-radio-group>
                          </v-flex>
                          <v-flex d-flex>
                            <v-layout class="padding-top-40">
                              <v-flex xs4 >
                                <v-menu
                                  ref="dateBeginMenu"
                                  v-model="dateBeginMenu"
                                  :disabled="periodSelector==='current'"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  class="min-width-190"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-on="on"
                                      v-model="dateBegin"
                                      label="Дата начала"
                                      readonly
                                      :disabled="periodSelector==='current'"
                                      @blur="dateBeginVal = parseDate(dateBegin)"
                                    />
                                  </template>
                                  <v-date-picker
                                    v-model="dateBeginVal"
                                    no-title
                                    scrollable
                                    locale="ru-RU"
                                    :max="dateEndVal"
                                    @input="dateBeginMenu = false"
                                  />
                                </v-menu>
                              </v-flex>

                              <v-flex xs4>
                                <v-menu
                                  ref="dateEndMenu"
                                  v-model="dateEndMenu"
                                  :close-on-content-click="false"
                                  :disabled="periodSelector==='current'"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  class="min-width-1  90"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      v-on="on"
                                      v-model="dateEnd"
                                      class="padding-left-10"
                                      :disabled="periodSelector==='current'"
                                      label="Дата окончания"
                                      readonly
                                      @blur="dateEndVal = parseDate(dateEnd)"
                                    />
                                  </template>
                                  <v-date-picker
                                    v-model="dateEndVal"
                                    no-title
                                    scrollable
                                    locale="ru-RU"
                                    :min="dateBeginVal"
                                    :max="currentPeriodEndDate"
                                    @input="dateEndMenu = false"
                                  />
                                </v-menu>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
<!--                      <v-flex>-->
<!--                        <v-layout>-->
<!--                          <v-flex xs6>-->
<!--                            <div class="padding-top-14">-->
<!--                              Группировать по-->
<!--                            </div>-->
<!--                          </v-flex>-->

<!--                          <v-flex xs6>-->
<!--                            <v-select-->
<!--                              v-model="dataGroup"-->
<!--                              :items="dataGroupItems"-->
<!--                              item-text="text"-->
<!--                              item-value="value"-->
<!--                              label=""-->
<!--                              persistent-hint-->
<!--                              single-line-->
<!--                            />-->
<!--                          </v-flex>-->
<!--                        </v-layout>-->
<!--                      </v-flex>-->
                      <v-flex>
                        <v-layout>
                          <v-flex xs6>
                            <div class="padding-top-14">
                              Формат отображаемой энергии
                            </div>
                          </v-flex>
                          <v-flex xs6>
                            <v-select
                              v-model="energyFormat"
                              :items="[
                                { state: 'кВатт*час (кВар/час)', abbr: 'kvch' },
                                { state: 'кВатт(кВар)', abbr: 'kv' },
                              ]"
                              item-text="state"
                              item-value="abbr"
                              label="Select"
                              persistent-hint
                              single-line
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex xs6>
                            <div class="padding-top-14">
                              Вид энергии
                            </div>
                          </v-flex>
                          <v-flex xs6>
                            <v-select
                              v-model="energyType"
                              :items="energyTypes"
                              item-text="text"
                              item-value="energy"
                              label="Вид энергии"
                              persistent-hint
                              single-line
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex>
                        <v-layout>
                          <v-flex xs6>
                            <v-layout
                              d-flex
                              xs12
                            >
                              <v-flex
                                d-flex
                                xs6
                              >
                                <v-checkbox
                                  v-if="energyType == 'straight'"
                                  v-model="showLost"
                                  hide-details
                                  label="Учёт потерь"
                                />
                                <v-flex
                                  d-flex
                                  xs2
                                >
                                  <v-btn
                                    v-if="showLost && energyType == 'straight'"
                                    :style="{ 'background-color': editedRepresent.lost_color }"
                                    class="pick-color-btn margin-top-18"
                                    @click.native="selectLostColor()"
                                  />
                                </v-flex>
                              </v-flex>
                            </v-layout>
                            <v-layout
                              d-flex
                              xs12
                            >
                              <v-flex
                                d-flex
                                xs10
                              >
                                <v-checkbox
                                  v-if="showLost && energyType == 'straight'"
                                  v-model="showLostInPercentage"
                                  hide-details
                                  label="Потери в процентах"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout
                              d-flex
                              xs12
                            >
                              <v-flex
                                d-flex
                                xs10
                              >
                                <v-checkbox
                                  v-if="energyType == 'straight'"
                                  v-model="reactiveEnergy"
                                  hide-details
                                  label="Реактивная энергия"
                                />
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs6>
                            <v-radio-group
                              v-model="valRound"
                              column
                            >
                              <v-radio
                                label="Без округления"
                                value="trunc"
                              />
                              <v-radio
                                label="Округление до целого с остатком"
                                value="round0"
                              />
                              <v-radio
                                style="width:160px"
                                label="Округление до N знаков"
                                value="roundWith"
                              />
                            </v-radio-group>
                            <v-select
                              v-model="roundVal"
                              class="rounding-selector"
                              :items="roundChoice"
                              item-text="round"
                              item-value="round"
                              label=""
                              persistent-hint
                              single-line
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="red darken-1"
                    text
                    @click.native="deleteRepresent"
                  >
                    Удалить
                  </v-btn>
                  <div
                    v-if="changed == false"
                    class="subheading"
                  >
                    <v-icon color="green">
                      check_circle
                    </v-icon>
                    Изменений нет
                  </div>
                  <div
                    v-else-if="changed == true"
                    class="px-3 save_block"
                  >
                    <v-btn
                      color="orange darken-1"
                      text
                      @click.native="saveRepresent"
                    >
                      Сохранить
                    </v-btn>
                    <v-btn
                      color="red darken-1"
                      text
                      @click.native="cancelRepresentChanges"
                    >
                      Отмена
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item value="rep-tab-points">
              <v-card
                v-if="!loadingRepresentAvailablePoints && lookAvailablePoints"
                flat
                class="form-factor-for-forms-full"
              >
                <v-card-title>
                  <span class="headline">Доступные точки учёта</span>
                  <v-spacer />
                  <v-btn
                    text
                    class="blue--text darken-1"
                    @click.native="closePointSelectDialog"
                  >
                    <v-icon>keyboard_arrow_left</v-icon>
                    <span>Назад</span>
                  </v-btn>
                </v-card-title>
                <v-card-title>
                  <v-spacer />
                  <v-text-field
                    v-model="pointSearch"
                    append-icon="search"
                    label="Наименование"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-card-text>
                  <v-data-table
                    :headers="availablePointsHeaders"
                    :items="representAvailablePoints"
                    :search="pointSearch"
                    item-key="point_id"
                    class="elevation-1 represent-available-points"
                    flat
                    fixed-header
                    dense
                    :footer-props="{
                      itemsPerPageText: 'Число ТУ на странице',
                      itemsPerPageOptions: [25, 50]
                    }"
                  >
                    <tr
                      slot="item"
                      slot-scope="props"
                    >
                      <td>
                        <v-checkbox
                          v-model="props.item.selected"
                          primary
                          hide-details
                          @click.native="doAdRmPoint(props.item, $event)"
                        />
                      </td>
                      <td>{{ props.item.name }}</td>
                      <td align="center">
                        <v-tooltip left v-if="props.item.represents != null">
                          <template v-slot:activator="{ on }">
                            <v-btn x-small outlined fab color="teal" v-on="on">{{ props.item.represents.length }}</v-btn>
                          </template>
                          <div v-for="represent in props.item.represents" v-bind:key="represent.represent_id">
                            Объект {{ represent.name }}
                          </div>
                        </v-tooltip>
                        <v-btn v-else x-small outlined fab color="teal">0</v-btn>
                      </td>
                      <td>{{ props.item.point_number }}</td>
                      <td>{{ props.item.customer_name }}</td>
                      <td>{{ props.item.address }}</td>
                    </tr>
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="error"
                      icon="warning"
                    >
                      Точка учёта содержащая "{{ pointSearch }}" не найдена.
                    </v-alert>
                  </v-data-table>
                </v-card-text>
              </v-card>

              <v-card v-else-if="addPoints">
                <v-card-title>
                  <span class="headline">Новая точка учета</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form ref="addPointForm">
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm12
                          md12
                        >
                          <v-text-field
                            v-model="newPoint.name"
                            label="Наименование"
                            :rules="pointAddRules"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                        >
                          <v-text-field
                            v-model="newPoint.point_number"
                            label="Идентификатор Точки учёта"
                            :rules="pointAddRules"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                        >
                          <v-autocomplete
                            v-model="newPoint.customer_id"
                            :items="customers"
                            label="Абонент"
                            item-text="name"
                            item-value="customer_id"
                            no-data-text="Нет доступных абонентов"
                            :menu-props="{maxHeight:'auto'}"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                        >
                          <v-text-field
                            v-model="newPoint.address"
                            label="Адрес"
                            :rules="pointAddRules"
                            required
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                        >
                          <v-text-field
                            v-model="newPoint.remark"
                            label="Примечание"
                          />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click.native="savePoint"
                  >
                    Сохранить
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click.native="closePointCreateDialog"
                  >
                    Отмена
                  </v-btn>
                </v-card-actions>
              </v-card>

              <v-card v-else flat>
                <v-card-title>

                  <v-flex xs12 class="panel-without-shadow">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <a class="represent-header-text represent-header-filter">
                            <v-icon>mdi-filter-outline</v-icon>
                            Колонки таблицы
                          </a>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-container>
                            <v-row>
                              <v-col cols="6" sm="4" v-for="header in representPointsHeaders">
                                <v-checkbox
                                  class="pt-0 mt-0"
                                  v-model="header.visible"
                                  hide-details
                                  :label="header.text"
                                />
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                  <v-flex xs12>
                    <a
                      class="represent-header-text represent-header-attach"
                      @click="getRepresentAvailablePoints"
                    ><v-icon>mdi-check-box-outline</v-icon> Присоединить точку учёта
                    </a>
                  </v-flex>
                  <v-flex xs12>
                    <a
                      class="represent-header-text represent-header-add"
                      @click="showPointCreateDialog"
                    ><v-icon>mdi-plus-box-outline</v-icon> Добавить точку учёта
                    </a>
                  </v-flex>
                </v-card-title>

                <v-data-table
                  v-if="representPoints.length > 0"
                  v-model="slctRepresentPoints"
                  :headers="slctRepresentPointsHeaders"
                  :items="representPoints"
                  class="represent-points"
                  :loadig="loadedRepresentPoints"
                  show-select
                  item-key="point_id"
                  hide-default-footer
                  disable-pagination
                  fixed-header
                  dense
                  @toggle-select-all="toggleAllRepresentPoints($event)"
                  @item-selected="needToUpdatePointsData=true"
                >
                  <template v-slot:header.data-table-select="{ on, props }">
                    <span>
                      <v-simple-checkbox v-bind="props" v-on="on"></v-simple-checkbox>
                      Отображать в отчёте
                    </span>
                  </template>
                  <template v-slot:item.data-table-select="{ item, select }">
                    <v-simple-checkbox
                      v-model="item.selected"
                      @input="select($event)"
                      title="Отображение или не отображение точки учета в режимах «График», «Таблицы» и «Показания счетчиков»"
                    />
                  </template>
                  <template v-slot:item.order_num="{ item }">
                    <v-edit-dialog
                      :return-value.sync="item.order_num"
                      lazy
                    >
                      <v-btn icon>{{ item.order_num }}</v-btn>
                      <v-text-field
                        slot="input"
                        v-model="item.order_num"
                        type="number"
                        label="Редактировать"
                        single-line
                        @keyup.enter="updatePointOrder(item.represent_point_id, item.order_num)"
                      />
                    </v-edit-dialog>
                  </template>
                  <template v-slot:item.customer_number="{ item }">
                    <span>
                      {{ item.customer_name }}
                    </span>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <router-link :to="'/points/' + item.point_id + '/edit'" title="Переход в режим «Точки учета»">
                      {{ item.name }}
                    </router-link>
                  </template>
                  <template v-slot:item.counter="{ item }">
                    <span>
                      <v-icon v-if="item.counter_id" small
                              :color="getResourceTypeIconColor(item.counter_model_resource_type_id)">
                        {{ getResourceTypeIcon(item.counter_model_resource_type_id) }}
                      </v-icon>
                      {{
                        item.counter_id ?
                        item.counter_serial_num + ' (' + item.counter_model_name + ')' :
                        'Счетчик не установлен'
                      }}
                      <v-btn v-if="item.counter_id"
                             icon title="Информация о значениях параметров счетчика на конкретную дату и время"
                             @click="getCounterParametersData(item)"
                          >
                      <v-icon>info</v-icon>
                    </v-btn>
                    </span>
                  </template>
                  <template v-slot:item.color="{ item }">
                    <v-btn
                      icon
                      class="represent-pick-color-btn ml-0"
                      @click.native="selectColor(item)"
                      title="Цвет графика показаний счетчика в режиме «График»"
                    >
                      <div :style="{ 'background-color': item.color }"></div>
                    </v-btn>
                  </template>
                  <template v-slot:item.sign="{ item, value }">
                    <span class="sign-change">
                      <v-btn
                        icon
                        class="mx-0"
                        @click="updatePointSign(item)"
                        title="Значение «+» или «-» показаний счетчика при отображении их в режиме «Таблицы», для расчета потерь в сети"
                      >
                        <v-icon
                          v-if="value == 1"
                          color="teal"
                        >add_box</v-icon>
                        <v-icon
                          v-if="value == -1"
                          color="teal"
                        >indeterminate_check_box</v-icon>
                        <v-icon
                          v-if="value == 0"
                          color="teal"
                        >exposure</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <template v-slot:item.is_active="{ item }">
                    <div
                      class="active-state-change"
                      :class="{ 'not-active-counter': !item.counter_is_active }"
                    ><div>
                      <v-btn
                        v-if="item.counter_id && item.counter_model_external_model === 'mercury_206'"
                        icon
                        @click="changeActiveState(item)"
                        title="Отключение счетчика в точки учета в реальном режиме времени"
                      >
                        <v-icon :color="item.counter_is_active ? 'red' : 'green'">
                          power_settings_new
                        </v-icon>
                      </v-btn>
                    </div></div>
                  </template>
                </v-data-table>
                <p v-else>Нет привязанных Точек учёта</p>
                <v-dialog
                  v-model="colorSelectDialog"
                  max-width="352px"
                >
                  <v-card>
                    <v-card-text>
                      <swatches-picker v-model="crntEditClr" />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click.native="selectColorCancel"
                      >
                        Отмена
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click.native="selectColorOk"
                      >
                        ОК
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import LineChart from '../shared-components/DynamicLineChart'
import CounterParametersData from './counters/CounterParametersData'
import { Swatches } from 'vue-color'

const API_URL = 'represents'

Date.prototype.toHHMM = function () {
  var hours = this.getUTCHours()
  var minutes = this.getMinutes()
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  return hours + ':' + minutes
}

export default {
  name: 'Represents',
  components: {
    LineChart,
    CounterParametersData,
    'swatches-picker': Swatches
  },
  props: ['model'],
  data () {
    return {
      pointAddRules: [
        v => !!v || 'Заполните это поле!'
      ],
      editPoint: null,
      changed: true,
      colorSelectDialog: false,
      pointAddDialog: null,
      counterId: '',
      counter: {},
      opacityLoadTable: '',
      dataGroup: 30,
      lookAvailablePoints: false,
      addPoints: false,
      dataGroupItems: [{ value: 30, text: '30 минут' }, { value: 60, text: '60 минут' }, { value: 1440, text: 'День' }],
      pointsDataLoading: false,
      pointSearch: '',
      dataFilterMonthMenu: false,
      dataFilterMonthVal: null,
      activeTab: null,
      dataTabs: null,
      editedRepresent: {},
      currentRepresent: {},
      loadingRepresentAvailablePoints: false,
      pointsDataHeaders: [],
      pointsData: [],
      editLostColor: false,
      availablePointsHeaders: [
        {
          text: '',
          sortable: false,
          align: 'center',
          value: 'selected' },
        {
          text: 'Наименование',
          sortable: false,
          align: 'center',
          value: 'name' },
        {
          text: 'Число объектов принадлежности',
          sortable: false,
          align: 'center',
          value: 'point_represents_number' },
        {
          text: 'Идентификатор',
          sortable: false,
          align: 'center',
          value: 'point_number' },
        {
          text: 'Абонент',
          sortable: false,
          align: 'center',
          value: 'customer_name' },
        {
          text: 'Адрес',
          sortable: false,
          align: 'center',
          value: 'address' }
      ],
      loadedRepresentPoints: false,
      representPoints: [],
      representPointsHeaders: [
        {
          text: '№ПП',
          sortable: false,
          value: 'order_num',
          visible: true },
        {
          text: 'Лицевой счёт Абонента',
          sortable: false,
          value: 'customer_number',
          visible: true },
        {
          text: 'Наименование',
          sortable: false,
          value: 'name',
          visible: true },
        {
          text: '№ счётчика и модель',
          sortable: false,
          value: 'counter',
          visible: true },
        {
          text: 'Адрес',
          sortable: false,
          value: 'address',
          visible: true },
        {
          text: 'Цвет',
          sortable: false,
          value: 'color',
          visible: true },
        {
          text: 'Знак',
          sortable: false,
          value: 'sign',
          visible: true },
        {
          text: 'Питание',
          sortable: false,
          value: 'is_active',
          visible: true }
      ],
      representAvailablePoints: [],
      defaultRepresent: {
        name: '',
        title: 'new'
      },
      pointsCountersValuesHeaders: [],
      pointsCountersValuesData: [],
      pointsCountersValuesDataLoading: false,
      currentRepresentId: null,
      pointsDataLabels: [],
      pointsDatasets: [],
      crntEditClr: 'red',
      needToUpdatePointsData: true,
      representIsLoading: true,
      periodSelector: 'current',
      dateBeginVal: null,
      dateBegin: null,
      closeOnContentClick: false,
      dateBeginMenu: false,
      dateEnd: null,
      dateEndMenu: false,
      dateEndVal: null,
      currentPeriodBeginDate: '',
      currentPeriodEndDate: '',
      energyFormat: 'kvch',
      showTableSum: true,
      valRound: 'roundWith',
      roundVal: 2,
      pointsCountersValuesCsvUrl: null,
      pointsProfileCsvUrl: null,
      roundChoice: [
        { round: 1 },
        { round: 2 },
        { round: 3 },
        { round: 4 },
        { round: 5 }],
      showLost: true,
      showLostInPercentage: false,
      getSum: false,
      postSum: false,
      countersData: null,
      energyType: 'straight',
      energyTypes: [
        { energy: 'straight', text: 'Прямая' },
        { energy: 'reverse', text: 'Обратная' }
      ],
      currentValueOnTime: '0',
      reactiveEnergy: false,
      valueOnTime: [],
      newPoint: {},
      customers: [],
      execInterval: null,
      lastHalfHourNum: 12,
      lastHalfHourNumDefault: 12,
      lastHalfHourNumMax: 168,
      needToRebuildRepresents: false,
      slctRepresentPoints: [],
      showCounterParametersData: false,
      infoCounterId: null
    }
  },
  computed: {
    slctRepresentPointsHeaders: function () {
      return this.representPointsHeaders.filter(function (header) {
        return header.visible
      })
    }
  },
  watch: {
    showLost: function (newShowLostVal) {
      this.needToUpdatePointsData = true
      localStorage.presentShowLost = newShowLostVal
    },
    showLostInPercentage: function (newShowLostInPercentageVal) {
      this.needToUpdatePointsData = true
      localStorage.presentShowLostInPercentage = newShowLostInPercentageVal
    },
    pointsDataLoading: function () {
      if (this.pointsDataLoading == false) {
        this.opacityLoadTable = 'opacity: 1'
      } else {
        this.opacityLoadTable = 'opacity: 0'
      }
    },
    'editedRepresent.name': function() {
      this.changed = true
    },
    'editedRepresent.remark': function() {
      this.changed = true
    },
    'editedRepresent.check_health': function() {
      this.changed = true
    },
    representPointsHeaders: {
      handler (newVal) {
        const parsed = JSON.stringify(Object(newVal))
        localStorage.setItem('representPointsHeaders', parsed)
      },
      deep: true
    },
    roundVal: function (newRoundVal) {
      this.needToUpdatePointsData = true
      localStorage.presentRoundVal = newRoundVal
    },
    valRound: function (newValRound) {
      this.needToUpdatePointsData = true
      localStorage.presentValRound = newValRound
    },
    dataGroup: function (newDataGroup) {
      this.needToUpdatePointsData = true
      localStorage.presentDataGroup = newDataGroup
    },
    periodSelector (newPeriodSelectorVal) {
      this.needToUpdatePointsData = true
      if (newPeriodSelectorVal == 'current') {
        this.dateBeginVal = this.currentPeriodBeginDate
        this.dateEndVal = this.currentPeriodEndDate
      }
      localStorage.presentPeriodSelectorVal = newPeriodSelectorVal
    },
    dateBeginVal (newDateBegVal) {
      this.dateBegin = this.formatDate(newDateBegVal)
      this.needToUpdatePointsData = true
      localStorage.presentDateBeginVal = newDateBegVal
    },
    dateEndVal (newDateEndVal) {
      this.dateEnd = this.formatDate(newDateEndVal)
      this.needToUpdatePointsData = true
      localStorage.presentDateEndVal = newDateEndVal
    },
    reactiveEnergy (newReactiveEnergy) {
      this.needToUpdatePointsData = true
      localStorage.presentReactiveEnergy = newReactiveEnergy
    },
    energyType (newEnergyType) {
      this.needToUpdatePointsData = true
      localStorage.presentEnergyType = newEnergyType
    },
    energyFormat (newEnergyFormat) {
      this.needToUpdatePointsData = true
      localStorage.presentEnergyFormat = newEnergyFormat
    },
    currentValueOnTime () {
      this.getPointsData()
    },
    '$route' (to, from) {
      this.getRepresentInfoApi(this.$route.params.representId)
      this.needToUpdatePointsData = true
      this.activeTab = 'rep-tab-points'
    },
    activeTab (val) {
      if (val === 'rep-tab-table' || val === 'rep-tab-cnt-val-table') {
        if (this.needToUpdatePointsData) {
          this.getPointsData()
          this.needToUpdatePointsData = false
        }
      }
      if (val === 'rep-tab-chart') {
        this.loadGraph()
      }
    },
    lastHalfHourNum (newVal, oldVal) {
      if (newVal != +newVal) {
        this.lastHalfHourNum = this.lastHalfHourNumDefault
        return
      }
      if (newVal > this.lastHalfHourNumMax) {
        this.lastHalfHourNum = this.lastHalfHourNumMax
        return
      }
      if (newVal === oldVal) {
        return
      }
      if (this.currentRepresentId) {
        this.getRepresentPoints()
      }
      localStorage.lastHalfHourNum = newVal
    }
  },
  mounted () {
    this.initGraphNames()
    if (localStorage.lastHalfHourNum) {
      this.lastHalfHourNum = localStorage.lastHalfHourNum
    }
    this.getRepresentInfoApi(this.$route.params.representId)
    var currentDate = new Date()
    this.currentPeriodBeginDate = this.parseDate(
      '01/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear()
    )
    this.currentPeriodEndDate = this.parseDate(
      currentDate.getDate() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear()
    )
    this.activeTab = 'rep-tab-points'
    this.needToUpdatePointsData = true
    this.dateBeginVal = localStorage.presentDateBeginVal || this.currentPeriodBeginDate
    this.dateEndVal = localStorage.presentDateEndVal || this.currentPeriodEndDate

    if (localStorage.getItem('representPointsHeaders')) {
      this.representPointsHeaders = JSON.parse(localStorage.getItem('representPointsHeaders'))
    }
    if (localStorage.presentPeriodSelectorVal) {
      this.periodSelector = localStorage.presentPeriodSelectorVal
    }

    if (localStorage.presentDataGroup) {
      this.dataGroup = Number(localStorage.presentDataGroup)
    }

    if (localStorage.presentEnergyFormat) {
      this.energyFormat = localStorage.presentEnergyFormat
    }
    if (localStorage.presentShowLost) {
      this.showLost = localStorage.presentShowLost
    }
    if (localStorage.presentShowLostInPercentage) {
      this.showLostInPercentage = localStorage.presentShowLostInPercentage
    }
    if (localStorage.presentReactiveEnergy) {
      this.reactiveEnergy = localStorage.presentReactiveEnergy
    }
    if (localStorage.presentEnergyType) {
      this.energyType = localStorage.presentEnergyType
    }
    if (localStorage.presentValRound) {
      this.valRound = localStorage.presentValRound
    }
    if (localStorage.presentRoundVal) {
      this.roundVal = localStorage.presentRoundVal
    }
  },
  methods: {
    initGraphNames () {
      this.valueOnTime = [{ 'text': 'Начало дня', 'val': 0 }]
      for (var i = 1; i < 48; i++) {
        this.valueOnTime.push({ 'text': new Date(30 * 60000 * i).toHHMM(), 'val': i * 30 })
      }
    },
    getRepresentInfoApi (id) {
      this.representIsLoading = true
      axios.get(`/api/${API_URL}/${id}/`)
        .then((response) => {
          this.editedRepresent = Object.assign({}, response.data)
          this.currentRepresent = Object.assign({}, response.data)
          this.currentRepresentId = id
          this.getRepresentPoints()
          setTimeout(() => this.changed = false, 10)
        })
        .catch((err) => {
          console.log(err)
          this.representIsLoading = false
        })
    },
    updateRepresentApi () {
      const representUpdateJson = {
        'represent_id': this.editedRepresent.represent_id,
        'name': this.editedRepresent.name,
        'remark': this.editedRepresent.remark,
        'lost_color': this.editedRepresent.lost_color,
        'check_health': this.editedRepresent.check_health,
        'health_check_ip': this.editedRepresent.health_check_ip,
        'health_check_port': this.editedRepresent.health_check_port
      }
      axios.put(`/api/${API_URL}/${representUpdateJson.represent_id}/`, representUpdateJson)
        .then((response) => {
          this.$emit('renameSelectedRepresent', this.editedRepresent.name)
          setTimeout(() => this.changed = false, 10)
          if (this.needToRebuildRepresents) {
            this.$emit('rebuildRepresents')
            this.needToRebuildRepresents = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    deleteRepresentApi () {
      const id = this.editedRepresent.represent_id
      axios.delete(`/api/${API_URL}/${id}`)
        .then((response) => {
          this.$router.push({ path: `/represent/new` })
          this.$emit('rebuildRepresents')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    loadGraph: function () {
      if (this.countersData == null || this.needToUpdatePointsData) {
        this.getPointsData(this.loadGraph)
        this.needToUpdatePointsData = false
        return
      }
      this.pointsDataLabels = this.countersData.items.map(data => data.counter_date)
      var pointsDatasets = []
      if (this.countersData.items.length !== 0) {
        var headersKeys = Object.keys(this.countersData.items[0])
        for (var headerKey in headersKeys) {
          if (headersKeys[headerKey] !== 'counter_date') {
            var color = this.countersData.points_colors[headersKeys[headerKey]]
            if (color === undefined) {
              color = 'red'
            }
            var borderDash = []
            if (headersKeys[headerKey].indexOf('reverse') > 0) {
              borderDash = [2, 2]
            }
            if (headersKeys[headerKey] === 'lost') {
              color = this.editedRepresent.lost_color
            }
            if (headersKeys[headerKey] === 'lost_percentage') {
              color = this.editedRepresent.lost_color
            }
            pointsDatasets.push({
              label: this.countersData.headers[headerKey].text,
              borderColor: color,
              borderDash: borderDash,
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: color,
              lineTension: 0,
              backgroundColor: 'transparent',
              pointRadius: 0,
              data: this.countersData.items.map(data => data[headersKeys[headerKey]])
            })
          }
        }
      }
      this.pointsDatasets = pointsDatasets
    },
    getProfileData: function (callback) {
      this.pointsDataLoading = true
      if (this.currentRepresentId === null) {
        return
      }
      var url = `/api/represents/${this.currentRepresentId}/points_profile_data/?interval=${this.dataGroup}&reactive_energy=${this.reactiveEnergy}&energy_type=${this.energyType}&energy_format=${this.energyFormat}`
      if (this.periodSelector == 'selected') {
        url += `&beginDate=${this.dateBeginVal}&endDate=${this.dateEndVal}`
      }
      if (this.showLost) {
        url += `&showLost=${this.showLost}`
      }
      if (this.showLostInPercentage) {
        url += `&showLostInPercentage=${this.showLostInPercentage}`
      }
      var pointsForReport = this.representPoints.reduce(function (filtered, point) {
        if (point.selected) {
          filtered.push(point.point_id)
        }
        return filtered
      }, [])
      url += `&points=${pointsForReport}`
      if (this.valRound === 'round0') {
        url += `&roundVal=0`
      } else if (this.valRound === 'trunc') {
        url += `&roundVal=-1`
      } else if (this.valRound === 'roundWith') {
        url += `&roundVal=${this.roundVal}`
      }
      this.pointsProfileCsvUrl = url.replace('points_profile_data', 'points_profile_csv')

      axios.get(url)
        .then(response => {
          this.pointsDataLoading = false
          this.pointsDataHeaders = response.data.headers
          this.pointsData = response.data.items
          this.countersData = response.data
          typeof callback === 'function' && callback()
        })
        .catch(err => {
          this.pointsDataLoading = false
          console.log(err)
        })
    },
    getPointsCountersValues () {
      if (this.currentRepresentId === null) {
        return
      }
      this.pointsCountersValuesDataLoading = true
      var url = `/api/represents/${this.currentRepresentId}/points_counters_values/?minutes_from_day_begin=${this.currentValueOnTime}`
      if (this.periodSelector == 'selected') {
        url += `&beginDate=${this.dateBeginVal}&endDate=${this.dateEndVal}`
      }
      this.pointsCountersValuesCsvUrl = url.replace('points_counters_values', 'points_counter_values_csv')
      axios.get(url)
        .then(response => {
          this.pointsCountersValuesHeaders = response.data.headers
          this.pointsCountersValuesData = response.data.items
          this.pointsCountersValuesDataLoading = false
        })
        .catch(err => {
          this.pointsCountersValuesDataLoading = false
          console.log(err)
        })
    },
    getPointsData (callback) {
      this.getProfileData(callback)
      this.getPointsCountersValues()
    },
    getRepresentPoints () {
      this.lookAvailablePoints = false
      this.addPoints = false
      axios.get(`/api/represents/${this.currentRepresentId}/points/`,
        { params: { halfs_num: this.lastHalfHourNum }})
        .then(response => {
          this.representPoints = response.data
          this.representPoints.map(function (x) {
            x.selected = true
            return x
          })
          this.slctRepresentPoints = this.representPoints
          this.loadedRepresentPoints = true
          this.representIsLoading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getRepresentAvailablePoints () {
      this.loadingRepresentAvailablePoints = true
      this.pointAddDialog = true
      this.lookAvailablePoints = true
      if (this.currentRepresentId != null) {
        axios.get(`/api/represents/${this.currentRepresentId}/available_points/`)
          .then(response => {
            this.representAvailablePoints = response.data
            this.loadingRepresentAvailablePoints = false
          })
          .catch(err => {
            this.loadingRepresentAvailablePoints = false
            console.log(err)
          })
      }
    },
    addPointToRepresent (pointId) {
      if (this.currentRepresentId != null) {
        axios.post(`/api/represents/${this.currentRepresentId}/add_point/?point_id=${pointId}`)
          .then(response => {
            this.getRepresentPoints()
            this.needToUpdatePointsData = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    delPointFromRepresent (pointId) {
      if (this.currentRepresentId != null) {
        axios.post(`/api/represents/${this.currentRepresentId}/del_point/?point_id=${pointId}`)
          .then(() => {
            this.getRepresentPoints()
            this.needToUpdatePointsData = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    doAdRmPoint (item) {
      if (item.selected) {
        this.addPointToRepresent(item.point_id)
      } else {
        this.delPointFromRepresent(item.point_id)
      }
      return true
    },
    deleteRepresent () {
      if (confirm('Вы действительно хотите удалить этот объект?')) {
        this.deleteRepresentApi()
      }
    },
    saveRepresent () {
      this.updateRepresentApi()
    },
    cancelRepresentChanges () {
      if (confirm('Вы уверены?')) {
        this.editedRepresent = Object.assign({}, this.currentRepresent)
        setTimeout(() => this.changed = false, 10)
      }
    },
    updatePointSign (item) {
      axios.post(`/api/represents/${this.currentRepresentId}/update_point_sign/?represent_point_id=${item.represent_point_id}`)
        .then(response => {
          item.sign = response.data.sign
          this.needToUpdatePointsData = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    changeActiveState(item) {
      let action = item.counter_is_active ? 'отключить' : 'включить'
      if (confirm(`Вы действительно хотите ${action} данный счётчик?`)) {
        axios.post(`/api/counters/${item.counter_id}/change_active_state/`)
          .then(() => {
            item.counter_is_active = item.counter_is_active != true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    updatePointColor (item) {
      axios.post(`/api/represents/${this.currentRepresentId}/update_point_color/?represent_point_id=${item.represent_point_id}`, { color: item.color })
        .then(() => {
          this.needToUpdatePointsData = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    closePointSelectDialog () {
      this.pointAddDialog = 0
      this.lookAvailablePoints = false
    },
    selectLostColor () {
      this.colorSelectDialog = true
      this.editLostColor = true
    },
    selectColor (item) {
      this.colorSelectDialog = true
      this.editPoint = item
    },
    selectColorOk () {
      this.colorSelectDialog = false
      if (this.editLostColor) {
        this.editLostColor = false
        this.editedRepresent.lost_color = this.crntEditClr.hex
        this.updateRepresentApi()
        this.getPointsData()
      } else {
        this.editPoint.color = this.crntEditClr.hex
        this.updatePointColor(this.editPoint)
      }
    },
    selectColorCancel () {
      this.colorSelectDialog = false
      this.editLostColor = false
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    updatePointOrder (repPointId, orderValue) {
      axios.post(`/api/represents/${this.currentRepresentId}/update_point_order/?represent_point_id=${repPointId}`,
        { 'order_num': orderValue })
        .then(() => {
          this.getRepresentPoints()
          this.needToUpdatePointsData = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCustomers () {
      axios.get(`/api/customers/`)
        .then((response) => {
          this.customers = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showPointCreateDialog () {
      if (this.customers.length === 0) {
        this.getCustomers()
      }
      this.addPoints = true
    },
    addPointApi () {
      axios.post(`/api/points/`, this.newPoint)
        .then((response) => {
          this.addPointToRepresent(response.data.point_id)
          this.closePointCreateDialog()
          this.getRepresentPoints()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    closePointCreateDialog () {
      this.addPoints = false
      setTimeout(() => {
        this.newPoint = {}
      }, 300)
    },
    validate () {
      if (this.$refs.addPointForm.validate()) {
        return true
      }
    },
    savePoint () {
      if (this.validate()) {
        this.addPointApi()
        this.addPoints = false
      }
    },
    toggleAllRepresentPoints ($event) {
      this.representPoints.forEach((item) => {
        item.selected = $event.value
      })
      this.needToUpdatePointsData = true
    },
    closeCounterParametersData () {
      this.showCounterParametersData = false
    },
    getCounterParametersData (item) {
      this.infoCounterId = item.counter_id
      this.showCounterParametersData = true
    },
    getResourceTypeIcon (resourceId) {
      if (resourceId == 1) {
        return 'fas fa-bolt'
      } else if (resourceId == 2) {
        return 'fas fa-tint'
      } else if (resourceId == 3) {
        return 'fas fa-fire'
      }
    },
    getResourceTypeIconColor (resourceId) {
      if (resourceId == 1) {
        return '#002DFFFF'
      } else if (resourceId == 2) {
        return '#36cffd'
      } else if (resourceId == 3) {
        return '#002DFFFF'
      }
    }
  }
}

</script>

<style lang="scss">
  .tab-active-class {
    background-color: #f8f8f8;
  }

  .panel-without-shadow {
    .v-expansion-panels {
      max-width: 800px;
      .v-expansion-panel {
        margin-top: 0;
      }
    }
    .v-expansion-panel:before {
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
    .v-expansion-panel:after {
      content: none !important;
    }
    .v-expansion-panel-header {
      min-height: auto !important;
      padding: 0 24px 0 0;
    }
    .v-expansion-panel-header__icon {
      display: none;
    }
    .v-expansion-panel-content__wrap {
      padding: 4px 18px 10px;
    }
    .v-card__text {
      padding: 10px 0 0;
    }
    .row > div {
      padding: 0;
    }
  }
  #line-chart {
    height: 500px !important;
  }
  line-chart {
    width: 800px;
    padding: 10px
  }
  .wide {
    width: 150px;
  }
  .table-fixed .v-data-table__wrapper table {
    width: 100%;
    tbody{
      height: 65vh;
      overflow-y:auto;
      width: 100%;
    }
    thead,tbody{
      display:block;
    }
    th {
      min-width: 90px;
      max-width: 90px;
      white-space: normal;
    }
    th:first-child, td:first-child {
      min-width: 140px;
      max-width: 140px;
    }
    td {
      min-width: 90px;
      max-width: 90px;
    }
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .no_data_color {
    background-color: #ff00005c;
  }
  .rounding-selector {
    width: 40px;
    position: relative;
    top: -55px;
    left: 200px;
  }
  .full-height {
    height: 100%;
  }
  .sign-change {
    margin-top: -6px;
  }
  .active-state-change {
    position: relative;
    height: 100%;
    margin: 0 -16px;
    padding-left: 16px;
    div {
      position: absolute;
      top: 50%;
      margin-top: -18px;
    }
  }
  .padding-top-14 {
    padding-top: 14px;
    width: 190px;
  }
  .padding-top-40 {
    padding-top: 40px;
  }
  .padding-left-10 {
    padding-left: 10px;
  }
  .margin-top-18 {
    margin-top: 19px;
  }
  .width-100px {
    width: 100px;
  }
  .width-150 {
    width: 150px;
  }
  .width-600px {
    width: 500px;
  }
  .width-160 {
    width: 160px;
  }
  .min-width-150 {
    min-width: 150px;
  }
  .min-width-290 {
    min-width: 290px;
  }
  .max-width-500 {
    max-width: 500px;
  }
  .max-width-800 {
    max-width: 800px;
  }
  .conf {
    .v-card__text {
      padding: 16px 0 0 0;
      .v-btn.pick-color-btn {
        min-width: auto; width: 20px; height: 20px;
      }
    }
    .v-text-field {
      padding-top: 0;
    }
    .v-messages {
      min-height: 0px;
    }
  }
  .v-btn--floating .v-btn__content {
    height: inherit;
  }
  .squares {
    letter-spacing: -5px !important;
  }
  .save_block {
    padding-top: 13px;
    padding-bottom: 16px;
  }
  .not-active-counter {
    background-color: #f5989830;
  }

  tr:hover .not-active-counter {
    background-color: unset;
  }
  .v-card__text.represents-page {
    padding: 0;
    .v-tabs {
      .v-tabs-bar {
        height: 52px;
        border-bottom: 0.5px solid #e6dede;
        .v-slide-group__wrapper {
          max-width: 1200px;
          .v-slide-group__content {
          }
          .v-tabs-slider-wrapper {
            height: 3px !important;
          }
          .v-tabs-slider {
            background-color: teal;
          }
          .v-tab {
            padding: 0;
            text-transform: none;
            color: #999;
          }
          .v-icon.v-icon {
            margin-bottom: 0;
            font-size: 30px;
            color: #ccc;
          }
          .v-tab:hover, .v-tab.tab-active-class {
            color: rgba(0,0,0,.87);
            .chart-tab {color: #ea301e;}
            .table-tab {color: #1ebd65;}
            .cnt-val-table-tab {color: #333db1;}
            .config-tab {color: #08beec;}
            .point-tab {color: #8699b7;}
          }
        }
      }
    }
    .v-window {
      position: absolute;
      height: calc(100% - 52px);
      bottom: 0;
      left: 0;
      right: 0;
      .v-window__container {
        height: 100%;
      }
      .v-card__title > div {
        line-height: 17px;
        font-weight: normal;
      }
      .represent-header-text {
        color: rgba(0,0,0,.87);
        font-size: 14px;
      }
      .represent-header-text > .v-icon {
        vertical-align: middle;
      }
      .represent-header-filter > .v-icon {
        color: rgba(0, 128, 128, 0.46);
      }
      .represent-header-attach > .v-icon {
        color: rgba(0, 128, 128, 0.59);
      }
      .represent-header-add > .v-icon {
        color: teal;
      }
    }
  }
  .v-window-item {
    height: 100%;
    & > .v-card {
      height: 100%;
    }
    //.v-data-table {
    //  position: absolute;
    //  right: 0;
    //  left: 0;
    //}
    .v-data-table__wrapper {
      max-height: 100%;
    }
  }
  .represent-table-tab .v-data-table {
    height: calc(100% - 64px);
  }
  .represent-cnt-val-tab .v-data-table {
    height: calc(100% - 106px);
  }
  .v-data-table.represent-points {
    height: calc(100% - 129px);
    .v-data-table__wrapper {
      padding-bottom: 9px;
    }
    table, th, td {
      border-style: solid;
      border-color: #e0d8d8;
    }
    table {
      border-width: 0 1px 1px 0;
    }
    th {
      border-width: 1px 0 0 1px;
    }
    td {
      border-width: 0 0 0 1px;
    }
  }
  .v-data-table.represent-available-points {
    height: calc(100% - 148px);
    .v-data-table__wrapper {
      padding-bottom: 12px;
    }
    .v-input {
      margin-top: 0;
      padding-top: 0;
    }
  }
  .represent-pick-color-btn div {
    width: 32px;
    height: 20px;
    border-radius: 2px;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }
  .v-data-table.v-data-table.represent-points .v-data-table__selected {
    background-color: unset;
  }
</style>



// WEBPACK FOOTER //
// src/spa/Represents.vue